import { render } from "./MaterialBankIndex.vue?vue&type=template&id=69ef4bfc"
import script from "./MaterialBankIndex.vue?vue&type=script&lang=js"
export * from "./MaterialBankIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__